const fromP3Item = (P3Item) => ({
  hi: P3Item.palletHigh,
  location: P3Item.locationCode,
  upc: P3Item.upcCode,
  itemId: P3Item.itemCode,
  ti: P3Item.palletTie,
  pack: P3Item.itemPack,
  description: P3Item.description,
  countryOfOrigin: null,
  certification: P3Item.certification,
  commodity: P3Item.commodity,
  isBurdenItem: (P3Item?.commodityId === 147 && P3Item?.itemGroupCode === 'M')
    || (P3Item?.commodityId === 188 && P3Item?.itemGroupCode === 'MB')
    || (P3Item?.commodityId === 174 && P3Item?.itemGroupCode === 'SB')
});

const fromCSVItem = (CsvItem) => ({
  description: CsvItem[2],
  hi: CsvItem[4] === '' ? null : CsvItem[4],
  ti: CsvItem[3] === '' ? null : CsvItem[3],
  location: CsvItem[13],
  pack: CsvItem[5] === '' ? null : CsvItem[5],
  cooler: CsvItem[14] === '' ? null : CsvItem[14],
  cost: CsvItem[6] === '' ? null : CsvItem[6],
  deliveredCost: CsvItem[7] === '' ? null : CsvItem[7],
  unitType: CsvItem[8] === '' ? null : CsvItem[8],
  countryOfOrigin: CsvItem[9],
  gtin: CsvItem[10] === '' ? null : CsvItem[10],
  upc: CsvItem[11] === '' ? null : CsvItem[11],
  plu: CsvItem[12] === '' ? null : CsvItem[12],
  commodity: CsvItem[13] === '' ? null : CsvItem[16],
  vendorItemId: CsvItem[15],
  itemId: CsvItem[0],
  vendorId: CsvItem[1]
});

export default fromP3Item;
export { fromCSVItem };
